var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.72266 4.38461C8.55469 4.38461 9.59766 3.80483 10.2188 3.03179C10.7812 2.33121 11.1914 1.35283 11.1914 0.374443C11.1914 0.241576 11.1797 0.108709 11.1562 0C10.2305 0.0362365 9.11719 0.640177 8.44922 1.44946C7.92188 2.06548 7.44141 3.03179 7.44141 4.02225C7.44141 4.1672 7.46484 4.31214 7.47656 4.36046C7.53516 4.37254 7.62891 4.38461 7.72266 4.38461ZM4.79297 19C5.92969 19 6.43359 18.2149 7.85156 18.2149C9.29297 18.2149 9.60938 18.9758 10.875 18.9758C12.1172 18.9758 12.9492 17.7921 13.7344 16.6325C14.6133 15.3039 14.9766 13.9994 15 13.939C14.918 13.9148 12.5391 12.9123 12.5391 10.0979C12.5391 7.65798 14.4141 6.5588 14.5195 6.47425C13.2773 4.63827 11.3906 4.58996 10.875 4.58996C9.48047 4.58996 8.34375 5.45963 7.62891 5.45963C6.85547 5.45963 5.83594 4.63827 4.62891 4.63827C2.33203 4.63827 0 6.59504 0 10.2912C0 12.5861 0.867188 15.014 1.93359 16.5842C2.84766 17.9129 3.64453 19 4.79297 19Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/apple-logo.8db61b90d25e45932c7231a5820c5c05.svg";
export { ForwardRef as ReactComponent };